export enum StructureType {
  CREATE_STRUCTURE_TYPE = "COMPANY",
}